"use client"

import * as React from "react"

import { cn } from "@/lib/utils"

interface FilaDesplegableProps {
  abierta: boolean
  onAlternar: () => void
  /** Lo que se ve siempre: iconos, nombre, estado. Lo pone quien llama. */
  cabecera: React.ReactNode
  /** Cuando no hay nada que desplegar, la fila deja de responder. */
  sinDetalle?: boolean
  className?: string
  title?: string
  children?: React.ReactNode
}

/**
 * Una fila que se despliega, sin tarjeta.
 *
 * Es la hermana plana de `SeccionPlegable`: aquella es una seccion de una
 * pagina -con su numero, su titulo y su descripcion-, y esta es una fila dentro
 * de una lista, cuya cabecera la pinta quien la usa.
 *
 * Estaba escrita cuatro veces en el Brain -el grupo de acciones, el plan, las
 * herramientas usadas y la fila de una herramienta-, cada una con su relleno y
 * su `hover` propios. El `<button>` crudo vive aqui, que es donde esta bien:
 * una fila que se despliega ES un boton -necesita `aria-expanded` y teclado-,
 * pero no es el componente `Button`, que traeria su altura y su relleno.
 */
export function FilaDesplegable({
  abierta,
  onAlternar,
  cabecera,
  sinDetalle = false,
  className,
  title,
  children,
}: FilaDesplegableProps) {
  return (
    <>
      <button
        type="button"
        title={title}
        aria-expanded={sinDetalle ? undefined : abierta}
        onClick={() => { if (!sinDetalle) onAlternar() }}
        className={cn(
          'flex w-full items-center gap-2 px-2 py-2 text-left transition-colors',
          sinDetalle ? 'cursor-default' : 'hover:bg-muted/30',
          className,
        )}
      >
        {cabecera}
      </button>
      {abierta && !sinDetalle ? children : null}
    </>
  )
}
